const WB_SECTION = 'wbSection';
const WB_ICON_CONTAINER = 'wbIconContainer';
const WB_ICON = 'wbIcon';
const WB_MESSAGE = 'wbMessage';
const WB_TITLE = 'wbTitle';
const WB_SUBTITLE = 'wbSubtitle';

export { WB_SECTION, WB_ICON_CONTAINER, WB_ICON, WB_MESSAGE, WB_TITLE, WB_SUBTITLE };
